export const ICICoreEnrollmentArray = [
	"Health Plan",
	"Flex Med",
	"Flex Care",
	"Group Long Term Disability",
	"Group Life Insurance(Free)",
	"Group Life Insurance(Optional)"
];
